import {
  DeleteOutlined,
  EyeOutlined,
  FilterOutlined,
  MessageOutlined,
  CloudUploadOutlined,
  FileDoneOutlined,
} from "@ant-design/icons";
import { Table, Tag } from "antd";
import { Link } from "react-router-dom";

export const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    align: "right",
    width: "4%",
    render: (text, record) => <b>{text}</b>,
  },
  {
    title: "اسم الجهة",
    dataIndex: "name",
    key: "name",
    align: "right",
    width: "30%",
  },
  {
    title: "مسمى المشروع",
    dataIndex: "pro_name",
    key: "pro_name",
    align: "right",
    width: "25%",
  },
  {
    title: "مسمى المجال",
    dataIndex: "field_name",
    key: "field_name",
    align: "right",
    width: "20%",
  },
  {
    title: "حالة الطلب",
    dataIndex: "request_status",
    key: "request_status",
    align: "right",
    width: "13%",
    filters: [
      { text: 'مقبول', value: 1},
      { text: 'تحت المراجعه', value: 2 },
      { text: 'مرفوض', value: 0 },
    ],
    render: (text, record) => {
      if (text === 1) return <Tag color="green">تم التقييم</Tag>;
      else if (text === 0) return <Tag color="red">لم يتم التقييم</Tag>;
      else return <Tag color="blue">تحت المناقشة</Tag>;
    },
  },
  {
    title: "المهام",
    key: "action",
    width: "8%",
    render: (text, record) => (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          maxWidth: "55px",
        }}
      >
        <Link
          to={`/screens/assigned-requests/${record.key}`}
          style={{ color: " #0B632D" }}
        >
          <EyeOutlined />
        </Link>
        <Link to={`/screens/chatting-page`} style={{ color: " #0B632D" }}>
          <MessageOutlined />
        </Link>
        {/*
          <Link to="/" style={{ color: " #0B632D" }}>
            <DeleteOutlined />
          </Link>
          */}
      </div>
    ),
    align: "right",
  },
];
export const data = [
  {
    key: "1",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "2",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    request_status: 2,
  },
  {
    key: "3",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 2,
  },
  {
    key: "4",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ديني",
    request_status: 0,
  },
  {
    key: "5",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 0,
  },
  {
    key: "6",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 0,
  },
  {
    key: "7",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 0,
  },
  {
    key: "8",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "9",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    request_status: 0,
  },
  {
    key: "10",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    request_status: 0,
  },
  {
    key: "11",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "12",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "13",
    name: "جمعية الصفا ",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "14",
    name: "جمعية الصفا ",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "15",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "16",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "17",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "18",
    name: " الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
  {
    key: "19",
    name: " الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
];

export const columnsAccountant = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    align: "right",
    width: "4%",
    render: (text, record) => <b>{text}</b>,
  },
  {
    title: " اسم الجهة",
    dataIndex: "name",
    key: "name",
    align: "right",
    width: "25%",
  },
  {
    title: "مسمى المشروع",
    dataIndex: "pro_name",
    key: "pro_name",
    align: "right",
    width: "23%",
  },
  {
    title: "اسم البنك",
    dataIndex: "bank_name",
    key: "bank_name",
    align: "right",
    width: "20%",
  },
  {
    title: "رقم الحساب",
    dataIndex: "bank_iban",
    key: "bank_iban",
    align: "right",
    width: "20%",
  },

  {
    title: "المهام",
    key: "action",
    width: "8%",
    render: (text, record) => (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          maxWidth: "55px",
        }}
      >
        <Link
          to={`/screens/assigned-requests/${record.key}`}
          style={{ color: " #0B632D" }}
        >
          <EyeOutlined />
        </Link>
        <Link to={`/screens`} style={{ color: " #0B632D" }}>
          <CloudUploadOutlined />
        </Link>
      </div>
    ),
    align: "right",
  },
];
export const dataAccountant = [
  {
    key: "1",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "2",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "3",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    bank_name: "بنك الأهلي التجاري",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "4",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ديني",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "5",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "6",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "7",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "8",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الأهلي التجاري",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "9",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "10",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "11",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "12",
    name: "جمعية الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "13",
    name: "جمعية الصفا ",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "14",
    name: "جمعية الصفا ",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "15",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "16",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "17",
    name: " الصفا الخيرية",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "18",
    name: " الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
  {
    key: "19",
    name: " الصفا الخيرية",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    bank_name: "بنك الراجحي",
    bank_iban: "KSA021135113513541",
    request_status: 0,
  },
];

export const columnsApplicant = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    align: "right",
    width: "4%",
    render: (text, record) => <b>{text}</b>,
  },
  {
    title: "رقم الطلب",
    dataIndex: "name",
    key: "name",
    align: "right",
    width: "20%",
  },
  {
    title: "مسمى المشروع",
    dataIndex: "pro_name",
    key: "pro_name",
    align: "right",
    width: "25%",
  },
  {
    title: "مسمى المجال",
    dataIndex: "field_name",
    key: "field_name",
    align: "right",
    width: "20%",
  },
  {
    title: "حالة الطلب",
    dataIndex: "request_status",
    key: "request_status",
    align: "right",
    width: "13%",
    filters: [
      { text: 'تحت الدراسه', value: 1},
      { text: 'مرفوض', value: 0 },
    ],
    render: (text, record) =>
      text === 1 ? (
        <Tag color="green">تحت الدراسه </Tag>
      ) : (
        <Tag color="red">مرفوض</Tag>
      ),
  },
  {
    title: "المهام",
    key: "action",
    width: "8%",
    render: (text, record) => (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          maxWidth: "55px",
        }}
      >
        <Link
          to={`/screens/assigned-requests/${record.key}`}
          style={{ color: " #0B632D" }}
        >
          <EyeOutlined />
        </Link>
        <Link to={`/screens`} style={{ color: " #0B632D" }}>
          <FileDoneOutlined />
        </Link>
      </div>
    ),
    align: "right",
  },
];
export const dataApplicant = [
  {
    key: "1",
    name: "SH20210012030598",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 1,
  },
  {
    key: "2",
    name: "SH20210012030574",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    request_status: 1,
  },
  {
    key: "3",
    name: "SH20210012030590",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 0,
  },
  {
    key: "4",
    name: "SH20210012030992",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ديني",
    request_status: 0,
  },
  {
    key: "5",
    name: "SH20210012030548",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 1,
  },
  {
    key: "6",
    name: "SH20210012030540",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 1,
  },
  {
    key: "7",
    name: "SH20210012030551",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "ثقافي",
    request_status: 1,
  },
  {
    key: "8",
    name: "SH20210012030520",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "تربوي",
    request_status: 1,
  },
  {
    key: "9",
    name: "SH20210012030554",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    request_status: 0,
  },
  {
    key: "10",
    name: "SH20210012030558",
    pro_name: "ابرار لتوعية الافراد",
    field_name: "اجتماعي",
    request_status: 1,
  },
  {
    key: "11",
    name: " SH20210012030550",
    pro_name: " لتوعية الافراد",
    field_name: "تربوي",
    request_status: 0,
  },
];

export const dataEOrg = [
  { title: "احتياج الجهة للدعم", desc: "4" },
  { title: "جهة موثوقة وذات مصداقية", desc: "5" },
  { title: "ذات مهنية ومؤسسية", desc: "4" },
];

export const dataECity = [
  { title: "حاجة المنطقة ", desc: "4" },
  { title: "وجود انحرافات عقدية وفكرية", desc: "2" },
  { title: "استراتيجية المنطقة", desc: "4" },
  { title: "قلة الداعمين", desc: "4" },
  { title: "مستوى نضج العمل الخيري", desc: "4" },
];
export const dataEProject = [
  { title: "ذو أولوية وحاجة", desc: "5" },
  { title: "ذو بعد تنموي", desc: "5" },
  { title: "موافق وضمن نشاط الجهة", desc: "5" },
  { title: "كامل خطة وعمليات المشروع", desc: "5" },
  { title: "تميز المشروع", desc: "5" },
  { title: "موافق لاستراتيجية المؤسسة", desc: "5" },
  { title: "وجود بعد الاستدامة", desc: "5" },
  { title: "وضوح الأهداف", desc: "5" },
  { title: "أثر وبصمة المشروع", desc: "5" },
  { title: "إمكانية التنفيذ", desc: "5" },
  { title: "عدد المستفيدين", desc: "5" },
  { title: "فئة المستفيدين", desc: "5" },
  { title: "اتساع نطاق المشروع", desc: "5" },
  { title: "مدير المشروع", desc: "5" },
  { title: "وجود شريك متميز ومتخصص", desc: "5" },
  { title: "واقعية الميزانية", desc: "5" },
  { title: "يعتبر مشروع دائم في الجهة", desc: "5" },
];

export const dataOrg = [
  { title: "اسم الجهة", desc: "جمعية الصفا الخيرية" },
  { title: "رقم تصريح الجهة", desc: "964120812020" },
  { title: "رقم الجوال", desc: "+99521454545" },
  { title: "مجال الجهة", desc: "اجتماعي" },
  { title: "المدير التنفيذي للجهة", desc: "محمد بن خالد" },
  { title: "رقم جوال المدير التنفيذي ", desc: "+99521454545" },
  { title: "المنطقة", desc: "صفوي" },
  { title: "المدينة", desc: "صفوي" },
  { title: "عنوان البريد الإلكتروني", desc: "elsafa@gmail.com" },
];

export const dataBank = [
  { title: "اسم البنك", desc: "بنك الراجحي " },
  { title: "رقم الحساب", desc: "KSA00421122534481534" },
  { title: "اسم الجهة المسجل لدى البنك", desc: "جمعية الصفا الخيرية" },
  {
    title: "صورة بطاقة بيانات الحساب البنكي",
    desc: "عرض الصورة",
    isLink: true,
  },
];

export const dataProject = [
  { title: "مسمى المشروع", desc: "توعية وتأهيل المجتمع لاستخدام التكنولوجيا" },
  {
    title: "خطاب رسمي مختوم من الجهة",
    desc: "عرض الملف",
    isLink: true,
  },
  { title: "مدير المشروع", desc: "محمد بن خالد" },
  { title: "رقم جوال مدير المشروع", desc: "+99521454545" },
  { title: "نوع المستفيدين", desc: "الذكور و الأناث " },
  { title: "فئة المستفيدين ", desc: " شباب وفتيات" },
  { title: "عدد المستفيدين ", desc: " 100,000 " },
  { title: "مجال المشروع", desc: "تعليمي" },
  { title: "ميزانية المشروع", desc: "5000 ريال" },
  { title: "مدة تنفيذ المشروع", desc: "60 يوم" },
  { title: "شركاء المشروع", desc: "برمج الخيرية" },
  { title: "المنطقة المستهدفة", desc: "صفوى" },
  { title: "المدينة", desc: "القصيم" },
  {
    title: "وصف المشروع",
    desc:
      "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.    ",
  },
  {
    title: "أهداف المشروع",
    desc:
      "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.    ",
  },

  {
    title: "خطة المشروع ومرفقات أخرى",
    desc: "عرض الملفات",
    isLink: true,
  },
];

export const dataForAccountant = [
  { title: "اسم الجهة", desc: "جمعية الصفا الخيرية" },
  { title: "اسم الجهة المسجل لدى البنك", desc: "جمعية الصفا الخيرية" },
  { title: "المنطقة", desc: "صفوي" },
  { title: "المدينة", desc: "صفوي" },
  { title: "عنوان البريد الإلكتروني", desc: "elsafa@gmail.com" },
];

export const dataBankForAccountant = [
  { title: "اسم البنك", desc: "بنك الراجحي " },
  { title: "رقم الحساب", desc: "KSA00421122534481534" },
  { title: "اسم الجهة المسجل لدى البنك", desc: "جمعية الصفا الخيرية" },
  {
    title: "صورة بطاقة بيانات الحساب البنكي",
    desc: "عرض الصورة",
    isLink: true,
  },
];

export const dataProjectForAccountant = [
  { title: "مسمى المشروع", desc: "توعية وتأهيل المجتمع لاستخدام التكنولوجيا" },
  { title: "ميزانية المشروع", desc: "50000 ريال" },
  { title: "المبلغ المقرر ", desc: "40000 ريال" },
  { title: "المنطقة المستهدفة", desc: "صفوى" },
  { title: "المدينة", desc: "القصيم" },
  {
    title: "خطة المشروع ومرفقات أخرى",
    desc: "عرض الملفات",
    isLink: true,
  },
];


export const dataOrgForApplicant = [
  { title: "اسم الجهة", desc: "جمعية الصفا الخيرية" },
  { title: "رقم تصريح الجهة", desc: "964120812020" },
  { title: "رقم الجوال", desc: "+99521454545" },
  { title: "مجال الجهة", desc: "اجتماعي" },
  { title: "المدير التنفيذي للجهة", desc: "محمد بن خالد" },
  { title: "رقم جوال المدير التنفيذي ", desc: "+99521454545" },
  { title: "المنطقة", desc: "صفوي" },
  { title: "المدينة", desc: "صفوي" },
  { title: "عنوان البريد الإلكتروني", desc: "elsafa@gmail.com" },
];

export const dataBankForApplicant = [
  { title: "اسم البنك", desc: "بنك الراجحي " },
  { title: "رقم الحساب", desc: "KSA00421122534481534" },
  { title: "اسم الجهة المسجل لدى البنك", desc: "جمعية الصفا الخيرية" },
  {
    title: "صورة بطاقة بيانات الحساب البنكي",
    desc: "عرض الصورة",
    isLink: true,
  },
];

export const dataProjectForApplicant = [
  { title: "مسمى المشروع", desc: "توعية وتأهيل المجتمع لاستخدام التكنولوجيا" },
  {
    title: "خطاب رسمي مختوم من الجهة",
    desc: "عرض الملف",
    isLink: true,
  },
  { title: "مدير المشروع", desc: "محمد بن خالد" },
  { title: "رقم جوال مدير المشروع", desc: "+99521454545" },
  { title: "نوع المستفيدين", desc: "الذكور و الأناث " },
  { title: "فئة المستفيدين ", desc: " شباب وفتيات" },
  { title: "عدد المستفيدين ", desc: " 100,000 " },
  { title: "مجال المشروع", desc: "تعليمي" },
  { title: "ميزانية المشروع", desc: "5000 ريال" },
  { title: "مدة تنفيذ المشروع", desc: "60 يوم" },
  { title: "شركاء المشروع", desc: "برمج الخيرية" },
  { title: "المنطقة المستهدفة", desc: "صفوى" },
  { title: "المدينة", desc: "القصيم" },
  {
    title: "وصف المشروع",
    desc:
      "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.    ",
  },
  {
    title: "أهداف المشروع",
    desc:
      "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق. إذا كنت تحتاج إلى عدد أكبر من الفقرات يتيح لك مولد النص العربى زيادة عدد الفقرات كما تريد، النص لن يبدو مقسما ولا يحوي أخطاء لغوية.    ",
  },

  {
    title: "خطة المشروع ومرفقات أخرى",
    desc: "عرض الملفات",
    isLink: true,
  },
];